import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { ServiceControllerGetAllCategories$Params } from 'src/app/api/fn/services/service-controller-get-all-categories';
import {
  ProductItem,
  ServiceCategory,
  ServiceItem,
  ServiceItemWithCategory,
} from 'src/app/api/models';
import { ServicesService } from 'src/app/api/services';

@Component({
  selector: 'app-modal-service-picker',
  templateUrl: './modal-service-picker.component.html',
  styleUrls: ['./modal-service-picker.component.scss'],
})
export class ModalServicePickerComponent {
  @ViewChild('dt1') dt1?: Table;
  @ViewChild('keywordFilter') keywordFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('serviceNameFilter') serviceNameFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('idFilter') idFilter?: AutoComplete;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];

  question_title: string;
  chosenProducts: ProductItem[];

  selectedServices: ServiceItemWithCategory[] = [];
  chosenServices: ServiceItemWithCategory[] = [];

  categories: ServiceCategory[] = [];
  loading = false;
  isLoading = false;
  totalRecords: number = 0;
  filteredService: any[] = [];
  selectedId?: any;
  visibleModal = false;

  detail?: ServiceItem;
  cat?: ServiceCategory;

  descriptionCtrl = new FormControl<string | undefined>(undefined, [Validators.required]);

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private serviceService: ServicesService
  ) {
    this.question_title = config.data!.question_title;
    this.chosenProducts = config.data!.chosenProducts;
    this.chosenServices = config.data!.chosenServices;
  }

  loadCats(event: TableLazyLoadEvent) {
    this.loading = true;
    const params: ServiceControllerGetAllCategories$Params = {
      limit: +event.rows!,
      skip: +event.first!,
    };
    if (event.globalFilter != null) {
      if (event.globalFilter[0] != null) {
        params.name = event.globalFilter[0];
      }
      if (event.globalFilter[1] != null) {
        params.service_name = event.globalFilter[1];
      }
      if (event.globalFilter[2] != null) {
        params.service_identifier = event.globalFilter[2];
      }
    }
    this.serviceService.serviceControllerGetAllCategories(params).subscribe({
      next: res => {
        ((this.categories = res.data.list), (this.totalRecords = res.data.count));
        this.loading = false;
      },
    });
    if (this.chosenServices) {
      this.selectedServices = this.chosenServices;
    }
  }

  filterService(event: AutoCompleteCompleteEvent) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.categories as any[]).length; i++) {
      let agreements = (this.categories as any[])[i];
      if (agreements.identifier.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(agreements);
      }
    }
    this.filteredService = filtered;
  }

  clear(table: Table) {
    table.clear();
    if (this.keywordFilter) {
      this.keywordFilter.nativeElement.value = '';
    }
    if (this.serviceNameFilter) {
      this.serviceNameFilter.nativeElement.value = '';
    }
    this.idFilter?.clear();
  }

  close() {
    this.ref.close();
  }

  save() {
    this.ref.close({ services: this.selectedServices });
  }

  isSelected(item: ServiceItemWithCategory): boolean {
    return this.selectedServices.some(s => s.id === item.id);
  }

  allDescriptionsSet(): boolean {
    for (let service of this.selectedServices) {
      if (!service.description || service.description.trim() === '') {
        return false;
      }
    }
    return true;
  }
}
